export const getUnPayViewAction = "MEMEBER_SERVICE/VIEW/UNPAY";
export const getViewSuccessAction = "MEMEBER_SERVICE/VIEW/UNPAY/SUCCESS";
export const getUnPayViewFailAction = "MEMEBER_SERVICE/VIEW/UNPAY/FAIL";
export const getUnPayViewResetAction = "MEMEBER_SERVICE/VIEW/UNPAY/RESET";
